import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import { applyTemplateParams } from 'site-modules/shared/components/lead-form/utils/utils';
import { LeadFormMarkdownView } from 'site-modules/shared/components/lead-form/lead-form-markdown-view/lead-form-markdown-view';
import { INSIDER_PATHS } from 'client/site-modules/shared/constants/profile/dashboard-paths';
import { Link } from 'site-modules/shared/components/link/link';

export function BaseThanksHeader({
  config: {
    text,
    explainingText,
    insiderLinkOut,
    titleClassNames,
    markdownViewClassNames,
    closeButtonCTA,
    closeButtonClassNames,
    closeButtonUrl,
    closeButtonTrackingId,
    closeDrawer,
    insiderBtnClasses,
  } = {
    insiderBtnClasses: 'btn-primary-b',
  },
  templateParams = [],
}) {
  return (
    <div className="base-thanks-header text-gray-darker mt-1_5 mb-1">
      {text && (
        <h3 className={classNames({ 'heading-3 mb-0_75': !titleClassNames }, titleClassNames)}>
          {applyTemplateParams(templateParams, text)}
        </h3>
      )}
      {explainingText && (
        <div className={classNames({ 'mt-0_5': !markdownViewClassNames }, markdownViewClassNames)}>
          <LeadFormMarkdownView markdown={explainingText} templateParams={templateParams} />
        </div>
      )}
      {insiderLinkOut && (
        <Link
          to={INSIDER_PATHS.INSIDER}
          className={classNames(
            'btn size-16 btn-sm px-2 py-0_75 text-white text-transform-none fw-medium',
            insiderBtnClasses
          )}
          data-tracking-id="nav_access_my_account"
          target="_blank"
        >
          View Your Dashboard
        </Link>
      )}
      {closeButtonCTA && closeButtonUrl && (
        <Link to={closeButtonUrl} className={closeButtonClassNames} data-tracking-id={closeButtonTrackingId}>
          <span>{closeButtonCTA}</span>
        </Link>
      )}
      {closeButtonCTA && !closeButtonUrl && (
        <button className={closeButtonClassNames} onClick={closeDrawer}>
          <span>{closeButtonCTA}</span>
        </button>
      )}
    </div>
  );
}

BaseThanksHeader.propTypes = {
  config: PropTypes.shape({
    text: PropTypes.string,
    explainingText: PropTypes.string,
    insiderLinkOut: PropTypes.bool,
    titleClassNames: PropTypes.string,
    markdownViewClassNames: PropTypes.string,
    closeButtonCTA: PropTypes.string,
    closeButtonClassNames: PropTypes.string,
    closeButtonUrl: PropTypes.string,
    closeButtonTrackingId: PropTypes.string,
    closeDrawer: PropTypes.func,
    insiderBtnClasses: PropTypes.string,
  }),
  templateParams: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.string,
    })
  ), // dynamic object
};
